export default __webpack_public_path__ + "static/media/Group -11.0151b78b.png";